import Category from "../components/Menu/Category/Category";
import TopSection from "../components/Menu/TopSection/TopSection";

export default function Menu({
  cart,
  setCart,
  active,
  setActive,
  showMessage,
  setShowMessage,
  loading,
  setLoading,
  showAllId,
  setShowAllId,
}) {
  return (
    <>
      <TopSection
        active={active}
        setActive={setActive}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        loading={loading}
        setLoading={setLoading}
      ></TopSection>
      <Category
        active={active}
        setActive={setActive}
        cart={cart}
        setCart={setCart}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
        loading={loading}
        setLoading={setLoading}
      ></Category>
    </>
  );
}
